import { render, staticRenderFns } from "./TransporterAssetDetails.vue?vue&type=template&id=d3fd4f8c&scoped=true"
import script from "./TransporterAssetDetails.vue?vue&type=script&lang=js"
export * from "./TransporterAssetDetails.vue?vue&type=script&lang=js"
import style0 from "./TransporterAssetDetails.vue?vue&type=style&index=0&id=d3fd4f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fd4f8c",
  null
  
)

export default component.exports